import { render } from "./ShareCategoryModal.vue?vue&type=template&id=3efcd64e&scoped=true"
import script from "./ShareCategoryModal.vue?vue&type=script&lang=js"
export * from "./ShareCategoryModal.vue?vue&type=script&lang=js"

import "./ShareCategoryModal.vue?vue&type=style&index=0&id=3efcd64e&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efcd64e"]])

export default __exports__